<template>
  <div style="padding: 10px">
    <!-- PC端功能区域 -->
    <div class="search-pc" style="margin: 10px 0">
      <el-button type="primary" @click="add">新增</el-button>
      <el-button type="warning" @click="refreshCache">刷新缓存</el-button>
    </div>
    
    <!-- 移动端操作区 -->
    <div class="search-mobile">
      <div class="action-btns">
        <el-button type="primary" size="small" @click="add">新增</el-button>
        <el-button type="warning" size="small" @click="refreshCache">刷新缓存</el-button>
      </div>
    </div>

    <!-- PC端搜索区域 -->
    <div class="search-pc" style="margin: 10px 0">
      <el-input v-model="search.configKey" placeholder="配置键" style="width: 20%" clearable></el-input>
      <el-input v-model="search.configDesc" placeholder="配置描述" style="width: 20%; margin-left: 5px" clearable></el-input>
      <el-button type="primary" style="margin-left: 5px" @click="load">查询</el-button>
      <el-button style="margin-left: 5px" @click="resetData">重置</el-button>
    </div>
    
    <!-- 移动端搜索 -->
    <div class="search-mobile">
      <div class="search-header" @click="searchCollapsed = !searchCollapsed">
        <span>搜索筛选</span>
        <i :class="searchCollapsed ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"></i>
      </div>
      <div class="search-content" v-show="!searchCollapsed">
        <el-input v-model="search.configKey" placeholder="配置键" clearable></el-input>
        <el-input v-model="search.configDesc" placeholder="配置描述" clearable></el-input>
        <div class="search-btns">
          <el-button type="primary" @click="load">查询</el-button>
          <el-button @click="resetData">重置</el-button>
        </div>
      </div>
    </div>

    <!-- PC端表格区域 -->
    <el-table v-loading="loading" :data="tableData" border stripe style="width: 100%" class="table-pc">
      <el-table-column prop="id" label="ID" width="80" sortable></el-table-column>
      <el-table-column prop="configKey" label="配置键" width="200" show-overflow-tooltip></el-table-column>
      <el-table-column prop="configValue" label="配置值" width="300" show-overflow-tooltip></el-table-column>
      <el-table-column prop="configDesc" label="配置描述" show-overflow-tooltip></el-table-column>
      <el-table-column label="操作" width="200">
        <template #default="scope">
          <el-button size="mini" type="primary" plain @click="handleEdit(scope.row)">编辑</el-button>
          <el-popconfirm title="确定删除吗？" @confirm="handleDelete(scope.row.id)">
            <template #reference>
              <el-button size="mini" type="danger">删除</el-button>
            </template>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    
    <!-- 移动端卡片 -->
    <div class="table-mobile" v-loading="loading">
      <div class="card-item" v-for="item in tableData" :key="item.id">
        <div class="card-row">
          <span class="card-label">配置键：</span>
          <span class="card-value">{{ item.configKey }}</span>
        </div>
        <div class="card-row">
          <span class="card-label">配置值：</span>
          <span class="card-value">{{ item.configValue }}</span>
        </div>
        <div class="card-row">
          <span class="card-label">描述：</span>
          <span class="card-value">{{ item.configDesc }}</span>
        </div>
        <div class="card-actions">
          <el-button size="small" type="primary" @click="handleEdit(item)">编辑</el-button>
          <el-popconfirm title="确定删除吗？" @confirm="handleDelete(item.id)">
            <template #reference>
              <el-button size="small" type="danger">删除</el-button>
            </template>
          </el-popconfirm>
        </div>
      </div>
    </div>

    <!-- 分页区域 -->
    <div class="pagination-wrapper">
      <el-pagination class="pagination-pc" @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="currentPage" :page-sizes="[5, 10, 20]" :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
      <el-pagination class="pagination-mobile" @current-change="handleCurrentChange"
          :current-page="currentPage" :page-size="pageSize" layout="total, prev, pager, next" :total="total"></el-pagination>
    </div>

    <!-- 新增/编辑弹窗 -->
    <el-dialog title="系统配置" v-model="dialogVisible" width="30%">
      <el-form :model="form" label-width="100px">
        <el-form-item label="配置键">
          <el-input v-model="form.configKey" style="width: 80%" placeholder="请输入配置键"></el-input>
        </el-form-item>
        <el-form-item label="配置值">
          <el-input type="textarea" v-model="form.configValue" style="width: 80%" placeholder="请输入配置值" :rows="3"></el-input>
        </el-form-item>
        <el-form-item label="配置描述">
          <el-input v-model="form.configDesc" style="width: 80%" placeholder="请输入配置描述"></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="save">确 定</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import request from "@/utils/request";

export default {
  name: 'sysConfig',
  data() {
    return {
      loading: true,
      dialogVisible: false,
      form: {},
      search: { configKey: '', configDesc: '' },
      currentPage: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      searchCollapsed: true
    }
  },
  created() {
    this.load();
  },
  methods: {
    load() {
      this.loading = true;
      const params = { current: this.currentPage, size: this.pageSize };
      if (this.search.configKey) params.configKey = this.search.configKey;
      if (this.search.configDesc) params.configDesc = this.search.configDesc;

      request.get("/sysConfig/listPage", { params: params }).then(res => {
        this.loading = false;
        if (res.code === '0') {
          this.tableData = res.data.records || [];
          this.total = res.data.total || 0;
        } else {
          this.$message.error(res.msg || '加载失败');
          this.tableData = [];
          this.total = 0;
        }
      }).catch(() => {
        this.loading = false;
        this.$message.error('网络错误，加载失败');
        this.tableData = [];
        this.total = 0;
      });
    },
    resetData() {
      this.search = { configKey: '', configDesc: '' };
      this.currentPage = 1;
      this.load();
    },
    add() {
      this.form = {};
      this.dialogVisible = true;
    },
    handleEdit(row) {
      this.form = JSON.parse(JSON.stringify(row));
      this.dialogVisible = true;
    },
    save() {
      if (!this.form.configKey) {
        this.$message.warning('请输入配置键');
        return;
      }

      if (this.form.id) {
        request.post("/sysConfig/update", this.form).then(res => {
          if (res.code === '0') {
            this.$message.success('更新成功');
            this.load();
            this.dialogVisible = false;
          } else {
            this.$message.error(res.msg || '更新失败');
          }
        });
      } else {
        request.post("/sysConfig/save", this.form).then(res => {
          if (res.code === '0') {
            this.$message.success('新增成功');
            this.load();
            this.dialogVisible = false;
          } else {
            this.$message.error(res.msg || '新增失败');
          }
        });
      }
    },
    handleDelete(id) {
      request.post("/sysConfig/delete/" + id).then(res => {
        if (res.code === '0') {
          this.$message.success('删除成功');
          this.load();
        } else {
          this.$message.error(res.msg || '删除失败');
        }
      });
    },
    refreshCache() {
      request.post("/sysConfig/refreshCache").then(res => {
        if (res.code === '0') {
          this.$message.success('缓存刷新成功');
        } else {
          this.$message.error(res.msg || '缓存刷新失败');
        }
      });
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.currentPage = 1;
      this.load();
    },
    handleCurrentChange(pageNum) {
      this.currentPage = pageNum;
      this.load();
    }
  }
}
</script>

<style scoped>
/* PC端/移动端显示控制 */
.search-mobile, .table-mobile, .pagination-mobile { display: none; }

/* 移动端搜索样式 */
.search-mobile .search-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  background: #f5f7fa;
  border-radius: 4px;
  cursor: pointer;
  margin-bottom: 10px;
}

.search-mobile .search-content {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px 0;
}

.search-mobile .search-btns {
  display: flex;
  gap: 10px;
}

.search-mobile .search-btns .el-button { flex: 1; }

.search-mobile .action-btns {
  display: flex;
  gap: 10px;
  margin-bottom: 10px;
}

/* 移动端卡片样式 */
.card-item {
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 12px;
  margin-bottom: 10px;
}

.card-row {
  display: flex;
  padding: 5px 0;
  font-size: 14px;
}

.card-label { color: #909399; width: 70px; flex-shrink: 0; }
.card-value { color: #303133; flex: 1; word-break: break-all; }

.card-actions {
  display: flex;
  gap: 10px;
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid #ebeef5;
}

/* 移动端适配 */
@media screen and (max-width: 768px) {
  .search-pc, .table-pc, .pagination-pc { display: none !important; }
  .search-mobile, .table-mobile, .pagination-mobile { display: block !important; }
  
  /* 暗色模式 */
  .search-mobile .search-header {
    background: #2a2a2a;
    color: #e6a23c;
    border: 1px solid #3a3a3a;
  }
  
  .search-mobile .search-content {
    background: #1a1a1a;
    padding: 10px;
    border-radius: 4px;
    margin-bottom: 10px;
  }
  
  .card-item {
    background: #2a2a2a;
    border: 1px solid #3a3a3a;
  }
  
  .card-label { color: #909399; }
  .card-value { color: #e6a23c; }
  .card-actions { border-top-color: #3a3a3a; }
}
</style>
